import { AccredibleIconComponentModule } from '@accredible-frontend-v2/new-components/icon';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type HintType = 'info' | 'success' | 'warning' | 'danger';

@Component({
  standalone: true,
  imports: [CommonModule, AccredibleIconComponentModule],
  selector: 'accredible-hint',
  templateUrl: './hint.component.html',
  styleUrls: ['./hint.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HintComponent {
  content = input<string>();
  icon = input<string>();
  type = input<HintType>('info'); // corresponds to the class name applied
  image = input<string>();
}
